import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useMidnightTableColumns = () => {
  const { t } = useTranslation(['common', 'dashboardTemplates']);

  return useMemo(
    () => [
      {
        id: 'date',
        label: t('common:date'),
        sortable: true,
        format: (value: unknown) => {
          if (!value) return '';
          return dayjs(value as string).format('DD MMM YYYY');
        },
      },
      {
        id: 'balance',
        label: t('dashboardTemplates:midnight_balance'),
        sortable: true,
        align: 'right' as const,
        format: (value: unknown) => {
          if (typeof value !== 'number') return '';
          return value.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        },
      },
      {
        id: 'equity',
        label: t('dashboardTemplates:midnight_equity'),
        sortable: true,
        align: 'right' as const,
        format: (value: unknown) => {
          if (typeof value !== 'number') return '';
          return value.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        },
      },
    ],
    [t],
  );
};
